export enum AvailableDirections {
  NONE = "none",
  UP = "up",
  DOWN = "down",
  BOTH = "both",
}
export type ToggleControllerType = Event & {
  detail: {
    direction: AvailableDirections;
    isActive: boolean;
  }
}